export enum AssetStatus {
Initialized,
Acquired,
Destructed,
Sold,
Depreciated,
}
